module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-2400.353c7ca3.svg";